module.exports = __webpack_public_path__ + "img/Can Pepsi .8b16b47a.png";